export default __webpack_public_path__ + "static/media/ic_info_blue.11cb5607.svg";